import {Pagination} from './Pagination';
import {IDataModel} from './IDataModel';
import {isUndefined} from "util";

export interface IDataFilter {
    limit?: number,
    page?: number,
    sort?: string,
    order?: string,
    fields?: Array<any>,
    q?: string,
    client_id?: number
}

export class DataTable {
    defaultDirection: string;
    public filter: IDataFilter = {
        limit: 10, //todo create const for all paginations in config
        page: 0
        //q: '',  todo uncomment this  for search
    };
    public entities: Array<any> = [];
    public pagination: Pagination = new Pagination();

    private once1: any;

    onPageChange: any = false;

    constructor(private model: IDataModel, fields?: Array<any>){
        this.filter.fields = fields;
    }

    fetch() {
        this.once1 = {};
        let o2 = this.once1;
        return new Promise((resolve, reject) => {
            this.model.getList(this.filter)
                .map((r) => {
                    if (r.json) return r.json();
                    return r;
                })
                .subscribe((body) => {
                    if (this.once1 !== o2) return;
                    this.entities = body.data;
                    this.pagination = new Pagination(body.pagination, this.filter.limit);
                    this.actualizeFilter();
                    resolve();
                }, reject)
        });
    }

    refresh() {
        this.setFilter({
            page: 0,
        });
        this.fetch();
    }

    setFilter(filter: IDataFilter) {
        for(let key in filter) {
            this.filter[key] = filter[key];
        }
        this.filter.page = 0;
        this.pagination.page = 0;
        this.pagination.limit = this.filter.limit;
        this.pagination.page = 1;
        this.fetch();
    }

    private actualizeFilter() {
        this.filter.page = this.pagination.page;
        this.filter.limit = this.pagination.limit;
    }

    setPage(page: number) {
        if (page < 1 || page > this.pagination.totalPages || page === this.pagination.page) {
            return false;
        }
        this.pagination.setPage(page);
        if (this.onPageChange) this.onPageChange('');
        this.actualizeFilter();
        return this.fetch();
    }

    setSort(field: string) {
        if ( this.filter.order === undefined) {
            this.filter.order = '1';
        } else {
            this.filter.order = this.filter.order == '0' ? '1' : '0';
        }

        this.filter.sort = field;
        this.pagination.setPage(1);
        this.actualizeFilter();

        return this.fetch();
    }
}


// WEBPACK FOOTER //
// ./src/app/services/DataTable.ts